<template lang="html">

  <section class="menu-superior row-between" :style="styles.bgbody">

    <h2 class="nombre" :move="showMenu">Hola {{ name }}</h2>

    <div class="row-end ais">

      <template v-if="!!doc">
        <a class="button actilla column-between" :href="doc.url" :style="styles.colorBasic" target="_blank"
          :title="doc.title">
          <icon-download-doc></icon-download-doc>
          <span v-html="doc.texto"></span>
        </a>
      </template>

      <template v-if="!!certificadoPracticas">
        <a class="button actilla column-between" :href="certificadoPracticas[lang]" :style="styles.colorBasic"
          target="_blank" title="Descargar certificado de prácticas">
          <icon-download-doc></icon-download-doc>
          <span>{{ $t('descargar_certificado') }}</span>
        </a>
      </template>

      <a @click="logout" class="button column-between" :style="styles.colorBasic">
        <icon-salir></icon-salir>
        salir
      </a>
    </div>
  </section>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import salir from '@/components/parts/icons/salir'
import downloadDOC from '@/components/parts/icons/download-doc'

export default {
  name: 'menu-superior',
  mounted() {
    if (this.brand.canRequestCertficadoPracticasTutorizadas) {
      setTimeout(e => {
        this.requestCertificadoPracticasTutorizadas().then(r => {
          this.certificadoPracticas = r;
        })
      }, 100)
    }
  },
  data: () => ({
    certificadoPracticas: ''
  }),
  components: {
    'icon-salir': salir,
    'icon-download-doc': downloadDOC
  },
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      doc: 'getDocSuperior',
      name: 'getUserName',
      showMenu: 'getShowMenu',
      brand: 'getBrand',
      lang: 'getLanguage'
    })
  },
  methods: {
    ...mapActions(['logout', 'requestCertificadoPracticasTutorizadas'])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.menu-superior {
  height: $top-height;
  width: 100%;
  padding: 20px;
}

.button {
  text-transform: uppercase;
  font-size: 10px;
  cursor: pointer;
  padding: 0 10px;
  max-height: 45px;

  svg {
    margin-bottom: 5px;
  }

  &.actilla {
    svg {
      height: 25px;
    }
  }
}

.nombre {
  font-size: 18px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  transition: .7s;
  padding-left: 60px;

  &[move=true] {
    padding-left: 0px;
  }
}

@media screen and (max-width: 1400px) {
  .menu-superior {
    height: 75px;
    padding: 10px 20px;
  }
}

@media screen and (max-width: 1023px) {
  .nombre {
    max-width: 80%;
    text-align: left;
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/menu-superior.vue